export default __webpack_public_path__ + "static/analysts_Architect_INTJ_strengths-6019d39cf0d99795ea0af88a6a88323e.svg";